<div
  [class.achieved]="kpiType() === 'achieved' || kpiType() === 'domain'"
  [class.not-achieved]="kpiType() === 'not-achieved' || kpiType() === 'vendor'"
  [class.actual]="kpiType() === 'actual' || kpiType() === 'owner-name'"
  [class.actual2]="kpiType() === 'owner-name'"
  [class.weight]="kpiType() === 'weight'"
  [class.in-progress]="kpiType() === 'in-progress' && kpiStatus().toString().toLowerCase() === 'in progress'"
  [class.completed]="kpiType() === 'in-progress' && kpiStatus().toString().toLowerCase() === 'completed'"
  [class.planned]="kpiType() === 'in-progress' && kpiStatus().toString().toLowerCase() === 'planned'"
  [class.actualStatus]="kpiType() === 'actualStatus'"
  [class.status]="kpiType() === 'status'"
  [class.output]="kpiType() === 'output'"
  [class.theme]="kpiType() === 'theme'"
  [class.in-mobile-screen]="isMobile()"
  class = "status-container"
>
  @if(kpiType() === 'achieved'){
    <div class="card3">
      Over Achieved
      @if(!isMobile())
      {
        <img class="arrow" src="assets/images/arrow-up.gif" />
      } @else {
        <img class="arrow mobile-arrow" src="assets/images/mobile/Course Up.svg" />
      }
    </div>
  }
  @if(kpiType() === 'actual'){
    <div class="card3">
      Actual : {{kpiStatus()}}
    @if(domainIndicator() && domainIndicator() !== '#')
    {
      <span
        (mouseenter)="overlayPanel ? overlayPanel.show($event) : ''" 
        (mouseleave)="overlayPanel ? overlayPanel.hide() : ''"
      >
        {{domainIndicator() || '' | truncateWord:2}}
      </span>
      @if(domainIndicator()!.split(" ").length > 2){
        <p-overlayPanel #overlayPanel dismissable="true">
          <section class="popover-section" [innerHTML]="domainIndicator()"></section>
        </p-overlayPanel>
      }
    }
    </div>
  }
  @if(kpiType() === 'weight'){
    <div class="card3">
      weight : {{kpiStatus()}}%
    </div>
  }
  @if(kpiType() === 'in-progress' || kpiType() === 'not-achieved' || kpiType() === 'vendor' || kpiType() === 'owner-name' || kpiType() === 'status'){
    <div class="card3">
      <span
        (mouseenter)="overlayPanel2 ? overlayPanel2.show($event) : ''" 
        (mouseleave)="overlayPanel2 ? overlayPanel2.hide() : ''"
        class = "kpi-status3"
      >
        {{kpiStatus().toString()}}
      </span>
      @if(kpiStatus().toString().length >= 8){
        <p-overlayPanel #overlayPanel2 dismissable="true">
          <section class="popover-section" [innerHTML]="kpiStatus().toString()"></section>
        </p-overlayPanel>
      }
    @if(kpiType() === 'vendor' && !kpiStatus())
    {
      N/A
    }
    </div>
  }
  @if(kpiType() === 'indicator')
  {
    <div class = "domainIndicator-status card3" [class.status-in-mobile]="isMobile()">
      <span 
        class = 'domainIndicator' 
        [ngStyle]="{
          'background' : domainIndicatorColor(),
          'font-size' : kpiStatus() === 'N/A' ? '12px' : '14px'
        }"
      >{{kpiStatus()}}</span>
    </div>
  }
  @if(kpiType() === 'domain'){
    <!-- <div class = "d-flex align-items-center p-0" style = "line-height:1;gap:5px"> -->
    <div class = "card3">
      <span
          (mouseenter)="overlayPanel3 ? overlayPanel3.show($event) : ''" 
          (mouseleave)="overlayPanel3 ? overlayPanel3.hide() : ''"
          class = "kpi-status3"
          style = "color:#00c48c"
        >
          {{kpiStatus()}}
        </span>
        @if(kpiStatus().toString().length >= 10){
          <p-overlayPanel #overlayPanel3 dismissable="true">
            <section class="popover-section" [innerHTML]="kpiStatus()"></section>
          </p-overlayPanel>
        }
    </div>
  }
  @if(kpiType() === 'actualStatus'){
    <div class="card3">
      ActualStatus : {{kpiStatus()}}%
    </div>
  }
</div>
